<template>
    <v-col
        :sm="12"
        :md="7"
        :lg="3"
        :xl="3">
        <div class="tes-card pa-5">
            <div class="mt-6 text-center">
                <p class="font-weight-bold">{{$t('client')}}</p>
                <span>
                    Смена тарифа для выбранного прибора учета недоступна
                </span>
            </div>
        </div>
    </v-col>
</template>

<script>
export default {
  name: "change-tariff-notif"
};
</script>
